import React from 'react';
import { GraduationCap, Briefcase, Rocket } from 'lucide-react';
import { experience } from '../mockData';

const gradients = [
  'from-cyan-500 to-blue-500',
  'from-purple-500 to-pink-500',
  'from-blue-500 to-indigo-500',
  'from-teal-500 to-emerald-500'
];

const Experience = () => {
  return (
    <section id="experience" className="py-20 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-blue-300/20 to-cyan-300/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-purple-300/20 to-pink-300/20 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <span className="text-transparent bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text font-bold text-sm uppercase tracking-wider">Professional Journey</span>
          <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-purple-900 bg-clip-text text-transparent mt-2">Experience & Education</h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-lg">
            A proven track record of excellence in medical practice and education
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Gradient timeline line */}
            <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-cyan-500 via-purple-500 to-pink-500"></div>

            {/* Timeline items */}
            <div className="space-y-8">
              {experience.map((item, index) => (
                <div key={item.id} className="relative flex items-start space-x-6 group">
                  {/* Icon */}
                  <div className={`flex-shrink-0 w-16 h-16 bg-gradient-to-br ${gradients[index]} rounded-2xl flex items-center justify-center shadow-xl z-10 transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300`}>
                    {index < 2 ? (
                      <Briefcase className="h-8 w-8 text-white" />
                    ) : (
                      <GraduationCap className="h-8 w-8 text-white" />
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1 bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-2 border-2 border-transparent group-hover:border-purple-200">
                    <div className="flex items-center space-x-2 mb-2">
                      <span className={`bg-gradient-to-r ${gradients[index]} text-white px-4 py-1 rounded-full text-sm font-semibold shadow-lg`}>{item.year}</span>
                      {index === 0 && <Rocket className="h-5 w-5 text-yellow-500 animate-bounce" />}
                    </div>
                    <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-blue-900 bg-clip-text text-transparent mb-2">{item.title}</h3>
                    <div className="text-purple-600 font-semibold mb-2">{item.organization}</div>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;